import { useState } from "react";

export default function useBszPlannerDialogs() {
  /**
   * =========================================================
   * ✅ PROJECT DIALOG
   * =========================================================
   */
  const [isProjectDialogOpen, setIsProjectDialogOpen] = useState(false);

  const [editingProject, setEditingProject] = useState(null);

  const [selectedSubject, setSelectedSubject] = useState(null);

  const [selectedWeek, setSelectedWeek] = useState(null);

  //not from context, just for this dialog!
  const [selectedClass, setSelectedClass] = useState(null);
  /**
   * =========================================================
   * ✅ OPEN CREATE
   * =========================================================
   */
  const openCreateProject = ({ subject, week, classData = null }) => {
    setEditingProject(null);
    setSelectedSubject(subject);
    setSelectedWeek(week);
    setSelectedClass(classData);

    setIsProjectDialogOpen(true);
  };

  /**
   * =========================================================
   * ✅ OPEN EDIT
   * =========================================================
   */
  const openEditProject = ({ project, subject, week, classData = null }) => {
    setEditingProject(project);

    setSelectedSubject(subject);
    setSelectedWeek(week);
    setSelectedClass(classData);

    setIsProjectDialogOpen(true);
  };

  /**
   * =========================================================
   * ✅ CLOSE
   * =========================================================
   */
  const closeProjectDialog = () => {
    setIsProjectDialogOpen(false);

    setEditingProject(null);

    setSelectedSubject(null);
    setSelectedWeek(null);
    setSelectedClass(null); //just for the dialog, not for the context if given because of teacherView!
  };

  /**
   * =========================================================
   * ✅ HELPERS
   * =========================================================
   */
  const isEditing = Boolean(editingProject);

  /**
   * =========================================================
   * ✅ EXPORT
   * =========================================================
   */
  return {
    // state
    projectDialogOpen: isProjectDialogOpen,

    editingProject,
    selectedSubject,
    selectedWeek,

    isEditing,
    selectedClass,

    // setters
    setProjectDialogOpen: setIsProjectDialogOpen,
    setSelectedClass,

    setEditingProject,
    setSelectedSubject,
    setSelectedWeek,

    // handlers
    openCreateProject,
    openEditProject,
    closeProjectDialog,
  };
}
